// extracted by mini-css-extract-plugin
export default {"header":"AdminHeader_header__ZSABQ","brand":"AdminHeader_brand__QFFjz"};